const $ = jQuery;
const APP = {};
